























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class VoucherTemplate extends Vue {
    @Prop({ type: [Number], default: 3 })
    cate!: number;

    @Prop({ type: [String, Object], default: {} })
    curItem!: Journal.Journal;

    tps: Invoice.VoucherTemplate | null = null
    mounted() {
        this.getTps()
    }
    // 获取凭证
    searchQuery: string = "";
    getTps() {
        Vue.axios
            .get(`vouchertemplate/findall?accountBookId=${this.$store.state.accountBook.id}&cate=${this.cate}&query=${this.searchQuery}`)
            .then(res => {
                this.tps = res.data
            });
    }
    // 删除凭证
    deleteTp(tp: Invoice.VoucherTemplate) {
        // this.$emit("update:shouldFetch", false);
        this.$confirm("亲，此操作将永久删除该模板, 是否继续?", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(() => {
            Vue.axios
                .post(`vouchertemplate/delete`, tp)
                .then(res => {
                    this.$emit("update:shouldFetch", true);
                    this.getTps();
                    this.$message({
                        type: "success",
                        message: "删除成功!"
                    });
                });
        }).catch(() => {
            this.$message({
                type: "info",
                message: "已取消删除"
            });
        });
    }
    // 新增模板
    newTp() {
        this.editTitle = "新增模板";
        this.showVoucher = true;
        this.$nextTick(() => {
            let voucher: any = this.$refs.voucher;
            voucher.resetVoucher();
            voucher.isTp = true;
            voucher.tpId = null;
            voucher.tpInit = 0;
        })
    }
    // 编辑模板
    editTitle: string = "";
    showVoucher: boolean = false;
    editTp(tp: Invoice.VoucherTemplate) {
        this.editTitle = "编辑模板";
        this.showVoucher = true;
        this.$nextTick(() => {
            let Comvoucher: any = this.$refs.voucher;
            Comvoucher.resetVoucher()
            Comvoucher.shouldGetInit = false;
            Comvoucher.isTp = true;
            Comvoucher.tpId = tp.id;
            Comvoucher.tpInit = tp.isInit;
            Comvoucher.tpName = tp.showName;
            let voucher = this.formatTp(tp)
            Comvoucher.getSubjectList(null, () => {
                Comvoucher.packVoucher(voucher);
                Comvoucher.tpName = tp.showName;
            })
        })
    }
    formatTp(tp: Invoice.VoucherTemplate) {
        let voucher = (<any>Object).assign({}, tp);
        voucher.voucherRecords = voucher.records;
        delete voucher.records
        let jftotal = 0, dftotal = 0;
        voucher.voucherRecords.forEach((v: any, ) => {
            v.foresubText = v.showNo + " " + v.showLongText;
            jftotal += +v.jfmoney;
            dftotal += +v.dfmoney;
        })
        voucher.jftotal = jftotal;
        voucher.dftotal = dftotal;
        return voucher
    }
    afterSave() {
        this.showVoucher = false;
    }
    // 使用模板
    useTem(tp: Invoice.VoucherTemplate) {
        this.$emit("use", tp);
    }
    async reset() {
        const action = await this.$confirm("亲，确定重置吗？重置之后之前新增的模板都将删除，恢复成预制模板", "温馨提示");
        if (action === "confirm") {
            await Vue.axios.post("vouchertemplate/reset", {
                accountBookId: this.$store.state.accountBook.id,
                cate: this.cate
            });
            await this.getTps();
        }
    }
}
